import React, { useState, useEffect, useRef, useContext } from 'react';
import { Box, Container, Typography, Paper, Grid, TextField, Button, ToggleButton, ToggleButtonGroup, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem, IconButton, Tooltip, Divider, Stack, FormHelperText, } from '@mui/material';
import { QrCode2 as PixIcon, CreditCard as CardIcon, ContentCopy as CopyIcon, CheckCircleOutline as SuccessIcon, Payment as PaymentIcon, VoiceOverOffRounded, FlashOffRounded, } from '@mui/icons-material';
import InputMask from 'react-input-mask';
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';
import { validaCpfCnpj, CartaoCreditoTipo, identificacaoNomeUsuarioLogado, identificacaoUsuarioLogado, identificacaoRazaoSocialUsuarioLogado } from '../../../utils';
import api from '../../../services/api';
import LogoN from '../../../assets/img/NAFIL_logoCurto.svg';
import QRCodeStyling from "qr-code-styling";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import PixLogo from '../../../assets/img/pix_logo.png'
import NAFIL_Logo from '../../../assets/img/NAFIL_logo.svg';
import Confirmacao from '../../../assets/img/confirmacao.svg';
import Exclamacao from '../../../assets/img/exclamacao.svg';
import './Comprovante.css';
import { MyContext } from '../../../context/MyContext';
import { useHistory } from 'react-router-dom';
import { set } from 'date-fns';
import { BrowserView, MobileView } from 'react-device-detect';

const COLORS = {
  primary: '#2e7d32',
  secondary: '#4caf50',
  light: '#e8f5e9',
};

const PagamentoAvulso = (props) => {
  let history = useHistory();
  const [filialAplicada, setFilialAplicada] = useState(1); // ALTERAR PARA 998 PARA EXECUTAR NO SITE
  const ref = useRef(null);
  const [usuarioLogado, setUsuarioLogado] = useState("");
  const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState("");
  const [nomeFullRazaoSocialLogado, setNomeFullRazaoSocialLogado] = useState("");
  const [metodoPagamento, setMetodoPagamento] = useState('pix');
  const [openPixModal, setOpenPixModal] = useState(false);
  const [carregandoParcelas, setCarregandoParcelas] = useState(false);
  const [parcelasDisponiveis, setParcelasDisponiveis] = useState([]);
  const [valor, setValor] = useState(null);
  const [tipoPagamento, setTipoPagamento] = useState();//0 para pix e 1 para cartão de crédito
  const [clienteId, setClienteId] = useState();
  const [clienteIdLoja, setClienteIdLoja] = useState();
  const [idFilial, setIdFilial] = useState(998); // 1 usado o um apenas para teste Para Produção 998
  const [nome, setNome] = useState(''); //nome que esta impresso no Cartão
  const [numeroCartao, setNumeroCartao] = useState('');
  const [cpf, setCpf] = useState('');
  const [vencimento, setVencimento] = useState('');
  const [cvv, setCvv] = useState('');
  const [parcela, setParcela] = useState(1);
  const [observacao, setObservacao] = useState('');
  const [intervalID, setIntervalID] = useState(0);
  const [erroValor, setErroValor] = useState(false);
  const [erroCpf, setErroCpf] = useState(false);
  const [erroNumeroCartao, setErroNumeroCartao] = useState(false);
  const [erroNome, setErroNome] = useState(false);
  const [erroVencimento, setErroVencimento] = useState(false);
  const [erroCvv, setErroCvv] = useState(false);
  const [erroParcelas, setErroParcelas] = useState(false);
  const [token, setToken] = useState(''); // Token para acesso ao site
  const [cartaoTipoCartao, setCartaoTipoCartao] = useState(1) // 0 - para débito e 1 para crédito
  const [dadosComprovante, setDadosComprovante] = useState({});
  const [abreComprovante, setAbreComprovante] = useState(false);
  const [abreTrarnsacaoRecusada, setTrarnsacaoRecusada] = useState(false);
  const { destinoPagina, setDestinoPagina } = useContext(MyContext);
  const [showingToast, setShowingToast] = useState(0);
  const [showingToastNeedLogin, setShowingToastNeedLogin] = useState(1);
  const [desabilitarBotao, setDesabilitarBotao] = useState(false);

  // const [_token, set_token] = useState("");

  // const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState('João Ávila Testador')
  //controle da tela de pix - melhorar no futuro

  const [carregando, setCarregando] = useState(false);
  const [telaPixAindaNaoGerado, setTelaPixAindaNaoGerado] = useState(true);
  const [payload, setPayload] = useState(null);


  const fazerBaixaSaton = {
    id_cliente: 0,
    id_cliente_loja: 0,
    tipo_pagamento: 0,
    valor_total_compras: 0.00,
    valor_total_devolucoes: 0.00,
    valor_total_creditos: 0.00,
    valor_total_descontos: 0.00,
    valor_total_receber: 0.00,
    saton: [],
    especie: [],
    fator: [],
    cartaoNumero: "",
    cartaoValidade: "",
    cartaoCVV: "",
    cartaoNome: "",
    cartaoParcelas: 1,
    cartaoModelo: 0,
    cartaoErro: 0,
    cartaoErroDescricao: "",
    pixCopiaCola: "",
    usuario_logado: "",
    nome_usuario_logado: "",
    operacaoExecutadaSucesso: 0,
    vezes: 1
  };

  const isValorValidoEPositivo = (val) => {
    if (!val) return false;
    const clean = val.replace(/\D/g, "");
    const numericValue = parseFloat(clean) / 100;
    return !isNaN(numericValue) && numericValue > 0;
  };

  useEffect(() => {
    let _userId = usuarioLogado.split('_')[0];
    let _userIdloja = usuarioLogado.split('_')[1];

    setClienteId(Number(_userId));
    setClienteIdLoja(Number(_userIdloja));

    // setCpf("021.231.407-67"); // LIXO
    // setNumeroCartao("374762001899999"); // LIXO
    // setNome("TESTE ROGERIO"); // LIXO
    // setVencimento("01/99"); // LIXO
    // setCvv("1234");  // LIXO   
    // setObservacao("TESTE ROGERIO"); // LIXO   
    // setValor("1,23"); // LIXO   


    //     setDadosComprovante({
    // "orderId":"123456",
    // "reference":"MEUPEDIDO12345",
    // "tid":"11132607211753454808",
    // "nsu":"128774153",
    // "authorizationCode":"685962",
    // "brandTid":"016268967022323",
    // "dateTime":"2026-07-21T17:58:58-03:00",
    // "amount":100,
    // "cardBin":"374762",
    // "last4":"2960",
    // "returnCode":"00",
    // "returnMessage":"Success.",
    // "links":
    // [
    // {"method":"GET","rel":"transaction","href":"https://api.userede.com.br/erede/v2/transactions/11132607211753454808"},
    // {"method":"POST","rel":"refund","href":"https://api.userede.com.br/erede/v2/transactions/11132607211753454808/refunds"}
    // ],
    // "Bandeira" : "AMEX",
    // "Parcelas": 1}); // LIXO
    // setTrarnsacaoRecusada(false); // LIXO
    // setAbreComprovante(true); // LIXO

    // setParcela('');

    setUsuarioLogado(sessionStorage.getItem("id_loja_usuario"));
    let usuarioComprasFaturado = sessionStorage.getItem("usuario_compras_faturado");
    if (usuarioComprasFaturado != 1) {
      setDestinoPagina("home");
      toastMensagemError("SOMENTE PARA CLIENTES FATURADOS!");
      history.push("/");
      return;
    }
    setNomeUsuarioLogado(identificacaoNomeUsuarioLogado());
    setUsuarioLogado(identificacaoUsuarioLogado());
    setNomeFullRazaoSocialLogado(identificacaoRazaoSocialUsuarioLogado());


    if (metodoPagamento === 'card' && isValorValidoEPositivo(valor)) {
      // console.log('Pesquisando as Parcelas Disponíveis...', valor);
      buscarECalcularParcelas(valor);
    } else {
      setParcelasDisponiveis([]);
    }
  }, [metodoPagamento, valor]);


  //APAGAR DEPOIS - LOGIN FAKE

  const PegarTokenTeste = async () => {
    let json = {
      "email": "motoboygiovanni01@nafil.com.br",
      "senha": "281280",
      "longitude": "007",
      "latitude": "008"
    }
    const response = await axios.post('https://whats.nafil.com.br/api/AppEntregas/Login', json);
    return response.data.token
  }
  //APAGAR DEPOIS ACIMA - LOGIN FAKE

  const SalvarEfetuarPagamento = async () => {

    //depois apagar 
    const _token = await PegarTokenTeste();

    // depois apagar 
    //criar metodo de verificação do mumero do cartão 

    const valorNumerico = valor ? parseFloat(PrepararValorParaApi(valor)) : 0;

    fazerBaixaSaton.id_cliente = Number(1234);
    fazerBaixaSaton.id_cliente_loja = Number(999);
    fazerBaixaSaton.valor_total_compras = valorNumerico.toFixed(2);
    fazerBaixaSaton.valor_total_devolucoes = valorNumerico.toFixed(2);
    //fazerBaixaSaton.valor_total_creditos = Number(valorTotalCreditosPagamentos).toFixed(2);
    //fazerBaixaSaton.valor_total_descontos = Number(valorDescontosPagamentos).toFixed(2);
    fazerBaixaSaton.valor_total_receber = valorNumerico.toFixed(2);
    fazerBaixaSaton.nome_usuario_logado = nomeUsuarioLogado;
    fazerBaixaSaton.tipo_pagamento = 3; // cartão
    fazerBaixaSaton.cartaoNumero = "MTz547kaAyyRP9xooknjJIbsewYSchF" + Buffer.from(numeroCartao).toString('base64');
    fazerBaixaSaton.cartaoValidade = "EvTIWqQ57d698BcmnIO65743aXkJ8511Dai" + Buffer.from(vencimento).toString('base64');
    fazerBaixaSaton.cartaoCVV = "GhiOoB1657pR8dSiexW25711Tr16unMS" + Buffer.from(cvv).toString('base64');
    fazerBaixaSaton.cartaoNome = "cHJ32pdmF0ZSBzdGF0aWAMgcXmVhZG9ubSQHkgSHR0cESAXNsaWVudCBfQ2xpZ324W50ID0gbmV3I25OpEh0dHBDbGllSKlBvbnQoKTs" + Buffer.from(nome.toUpperCase()).toString('base64');
    fazerBaixaSaton.cartaoParcelas = parcela;
    fazerBaixaSaton.cartaoModelo = (3 + cartaoTipoCartao); //

    // selectionModel.forEach(el => {
    //   let newLinha = Object.assign({});
    //   newLinha.ids_saton = Number(el.split('-')[0]);
    //   newLinha.ids_saton_loja = Number(el.split('-')[1]);
    //   fazerBaixaSaton.saton.push(newLinha);
    //   newLinha = null;
    // });

    // console.log("217 - ", _token);

    const config = {
      headers: {
        'Authorization': `Bearer ${_token}`,
        'Content-Type': 'application/json'
      },
    }

    let _impProcessoID = 0;
    let _impProcessoIDLoja = 0;
    let _impProcessoErroPagamento = "";

    api.post('Saton/EfetuarPagamentoFaturado', JSON.stringify(fazerBaixaSaton), config).then(res => {
      // console.log("SUCESSO ", res.data);
      if (res.data.cartaoRetornoMessage != null && res.data.cartaoRetornoMessage != "") {
        toastErroPagamentoCartao("FALHOU: " + res.data.cartaoRetornoCodigo.toString() + " - " + res.data.cartaoRetornoMessage.toString());
      }
      else if (res.data.fator != null) {
        _impProcessoID = res.data.fator[0].ids_fator;
        _impProcessoIDLoja = res.data.fator[0].ids_loja_fator;
        //setSatonImpressaoProcessoId(res.data.fator[0].ids_fator);
        //setSatonImpressaoProcessoIdLoja(res.data.fator[0].ids_loja_fator);
      }
    }).catch(erro => {
      // console.log("ERROR ", erro);
      toastMensagemError("FALHOU: " + erro.ToString());
    });

    if (_impProcessoID > 0) {
      let _htmlPrint = "";
      toastSucessoPagamentoCartao();
    }
  }

  //Mensagens do Toast

  const toastMensagemError = (mensagem) => toast.error(mensagem,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const toastErroPagamentoCartao = (mensagem) => toast.error(mensagem,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const PixCopiadoComSucesso = (mensagem) => toast.success(mensagem,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 })

  const ErroPix = (mensagem) => toast.error(mensagem,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const toastSucessoPagamentoCartao = (mensagem) => toast.success(mensagem,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 })

  const copiarPix = () => {
    const pixCode = payload;
    navigator.clipboard.writeText(pixCode);
    PixCopiadoComSucesso('Código Pix copiado para a área de transferência!');
  };

  //Fim das mensagens de Toast

  const buscarECalcularParcelas = async (_valor) => {
    try {
      setCarregandoParcelas(true);
      // console.log('iniciando a busca de parcelas');
      // console.log('valor que está chegando no parâmetro ', _valor);

      // depois apagar 
      const _token = await PegarTokenTeste();
      // depois apagar 

      const valorParaApi = PrepararValorParaApi(_valor);
      // console.log('valor ', _valor);
      // console.log('valor para api ', valorParaApi);
      // console.log("293 - ", _token);

      const response = await fetch(`https://whats.nafil.com.br/api/Prazos/${valorParaApi}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${_token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ao buscar os prazos na API. Status: ${response.status}`);
      }

      const data = await response.json();
      const limiteParcelas = Array.isArray(data) ? data[0].prestacao : data.prestacao;

      if (!limiteParcelas) {
        throw new Error('Número de prestações não encontrado na resposta da API');
      }

      let valorNumerico = parseFloat(valorParaApi);

      // console.log('valor com _', _valor)

      const listaCalculada = [];

      for (let i = limiteParcelas; i >= 1; i--) {

        const valorDaParcela = valorNumerico / i;

        const valorFormatadoBRL = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(valorDaParcela);

        listaCalculada.push({
          value: i,
          label: `${i} parcelas x de ${valorFormatadoBRL} sem juros`
        });
      }
      setParcelasDisponiveis(listaCalculada);
    } catch (error) {
      console.error("Falha ao processar as parcelas:", error.message);
      setParcelasDisponiveis([]);
    } finally {
      setCarregandoParcelas(false);
    }
  };

  const FormatarValorMoeda = (value) => {
    const amount = value.replace(/\D/g, "");
    if (!amount) return "";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(parseFloat(amount) / 100);
  };

  // ESSA FUNÇÃO TEM NO BACKEND TAMBÉM
  const mensagensRede = {
    "00": "TRANSAÇÃO APROVADA",
    "05": "TRANSAÇÃO NÃO AUTORIZADA",
    "101": "PROBLEMAS NO CARTÃO, CONTATE A CENTRAL DO CARTÃO",
    "102": "CONFIRME A SITUAÇÃO DA LOJA COM A CENTRAL DO CARTÃO",
    "103": "NÃO AUTORIZADO. POR FAVOR, TENTE NOVAMENTE",
    "104": "NÃO AUTORIZADO. POR FAVOR, TENTE NOVAMENTE",
    "105": "NÃO AUTORIZADO.	CARTÃO RESTRITO",
    "106": "ERRO NO PROCESSAMENTO. TENTE NOVAMENTE",
    "107": "NÃO AUTORIZADO. POR FAVOR, TENTE NOVAMENTE",
    "108": "NÃO AUTORIZADO. VALOR NÃO PERMITIDO PARA ESTE TIPO DE CARTÃO",
    "109": "NÃO AUTORIZADO. CARTÃO INEXISTENTE",
    "110": "NÃO AUTORIZADO. TIPO DE TRANSAÇÃO NÃO PERMITIDA PARA ESTE CARTÃO",
    "111": "NÃO AUTORIZADO. SALDO INSUFICIENTE",
    "112": "NÃO AUTORIZADO. CARTÃO EXPIRADO",
    "113": "NÃO AUTORIZADO. EMISSOR IDENTIFICOU RISCO MODERADO",
    "114": "NÃO AUTORIZADO. O CARTÃO NÃO PERTENCE A REDE DE PAGAMENTO",
    "115": "NÃO AUTORIZADO. LIMITE DE TRANSAÇÕES PERMITIDAS NO PERÍODO FOI EXCEDIDO",
    "116": "NÃO AUTORIZADO. POR FAVOR, CONTATE A CENTRAL DO CARTÃO",
    "117": "TRANSAÇÃO NÃO ENCONTRADA",
    "118": "NÃO AUTORIZADO. CARTÃO BLOQUEADO",
    "119": "NÃO AUTORIZADO. CÓDIGO DE SEGURANÇA INVÁLIDO",
    "121": "ERRO NO PROCESSAMENTO. POR FAVOR, TENTE NOVAMENTE",
    "122": "TRANSAÇÃO ENVIADA PREVIAMENTE",
    "123": "NÃO AUTORIZADO. PORTADOR SOLICITOU ENCERRAMENTO DA RECORRÊNCIA NA CENTRAL DO CARTÃO",
    "124": "NÃO AUTORIZADO. NÃO AUTORIZADO. CONTATE A REDE",
    "170": "TRANSAÇÃO ZERO DOLLAR NÃO PERMITIDA PARA ESTE CARTÃO",
    "172": "CVC2 EXIGIDO PARA TRANSAÇÃO ZERO DOLLAR",
    "174": "TRANSAÇÃO ZERO DOLLAR APROVADA",
    "175": "TRANSAÇÃO ZERO DOLLAR NEGADA",
  };

  const traduzirMensagem = (returnCode, returnMessage) => {
    return mensagensRede[returnCode] || returnMessage;
  };

  const PrepararValorParaApi = (value) => {
    if (!value) return "0.00";
    const valorFormatado = value;
    return valorFormatado
      .replace("R$", "")
      .trim()
      .replace(/\./g, "")
      .replace(",", ".");
  }

  const handleValorChange = (e) => {
    setValor(FormatarValorMoeda(e.target.value));
    if (erroValor) setErroValor(false);
  };

  const handleMetodoChange = (event, newMetodo) => {
    if (newMetodo !== null) {
      setMetodoPagamento(newMetodo);
    }
  };

  const validateValor = () => {
    const numericValue = valor ? parseFloat(valor.replace(/\D/g, "")) / 100 : 0;
    setErroValor(!numericValue || numericValue <= 0);
  };

  const validateCpf = () => {
    setErroCpf(!validaCpfCnpj(cpf));
  };

  const validateNumeroCartao = () => {
    const numeroLimpo = numeroCartao.replace(/\s/g, '');
    setErroNumeroCartao(numeroLimpo.length < 13 || numeroLimpo.length > 19);
  };

  const validateNomePortador = () => {
    setErroNome(!nome || nome.trim().split(' ').length < 2);
  };

  const validateVencimento = () => {
    if (!vencimento || vencimento.includes('_')) {
      setErroVencimento(true);
      return;
    }

    const [mes, anoStr] = vencimento.split('/');
    const mesInt = parseInt(mes);
    const anoInt = parseInt(anoStr);
    const hoje = new Date();
    const anoAtual = hoje.getFullYear() % 100;
    const mesAtual = hoje.getMonth() + 1;

    if (mesInt < 1 || mesInt > 12 || anoInt < anoAtual) {
      setErroVencimento(true);
    } else if (anoInt === anoAtual && mesInt < mesAtual) {
      setErroVencimento(true);
    } else {
      setErroVencimento(false);
    }
  };

  const validateCvv = () => {
    setErroCvv(cvv.length < 3);
  };

  const validateParcelas = () => {
    setErroParcelas(!parcela);
  };

  const validateAll = () => {

    // console.log("ROGER ", parseFloat(valor.replace(/\D/g, "")));

    const isValorValid = valor ? parseFloat(valor.replace(/\D/g, "")) > 0 : false;
    const isCpfValid = validaCpfCnpj(cpf);
    const numeroLimpo = numeroCartao.replace(/\s/g, '');
    const isNumeroValid = numeroLimpo.length >= 13 && numeroLimpo.length <= 19;
    const isNomeValid = nome && nome.trim().split(' ').length >= 2;
    let isVencimentoValid = false;
    if (vencimento && !vencimento.includes('_')) {
      const [m, a] = vencimento.split('/').map(v => parseInt(v));
      const hoje = new Date();
      const anoAt = hoje.getFullYear() % 100;
      const mesAt = hoje.getMonth() + 1;
      if (m >= 1 && m <= 12 && a >= anoAt) {
        if (!(a === anoAt && m < mesAt)) {
          isVencimentoValid = true;
        }
      }
    }
    const isCvvValid = cvv.length >= 3;
    const isParcelasValid = !!parcela;
    setErroValor(!isValorValid);
    setErroCpf(!isCpfValid);
    setErroNumeroCartao(!isNumeroValid);
    setErroNome(!isNomeValid);
    setErroVencimento(!isVencimentoValid);
    setErroCvv(!isCvvValid);
    setErroParcelas(!isParcelasValid);
    return isValorValid && isCpfValid && isNumeroValid && isNomeValid && isVencimentoValid && isCvvValid && isParcelasValid;
  };

  const functionCopyToClipboard = async (e) => {
    // navigator.clipboard.writeText(_dadosPedido?.pixCopiaCola);
    // pixCopiadoSucesso("PIX Copiado com Sucesso K");
  }

  async function verificarPagamentosPIX() {
    //trazendo dados da api para erificar o pagamento do pix
  }

  function FormatarMoeda(valor) {

    if (valor === null || valor === undefined || valor === "")
      return "0,00";

    const numero = Number(valor) / 100;

    return numero.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function FormatarDataHora(dataHora) {
    if (!dataHora)
      return "";

    const data = new Date(dataHora);

    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();

    const hora = String(data.getHours()).padStart(2, "0");
    const minuto = String(data.getMinutes()).padStart(2, "0");
    const segundo = String(data.getSeconds()).padStart(2, "0");

    return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
  }

  function imprimirComprovante() {
    const conteudo = document.getElementById("comprovante_impressao").innerHTML;
    const janela = window.open("", "_blank", "width=700,height=700");
    janela.document.write(`
        <html>
            <body>
                ${conteudo}
            </body>
        </html>
    `);
    janela.document.close();
    janela.focus();
    janela.print();
    janela.close();
    window.onafterprint = () => {
      window.location.reload();
    };
  }

  async function verificarPagamentosPIX(a, b) {

    // if (_dadosPedido?.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).length > 0) { // 17
    //   _dadosPedido.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).map((xpag) => { // 17
    //     api.get(`Pedidos/PIXVerificarPagamentoEfetuado/${xpag.venda_id}/${xpag.venda_loja}/${xpag.especie_id}/${xpag.especie_loja}/${xpag.valor}`).then(res => {
    //       if (res.status == 200 && res?.data != null && res?.data?.message == null) {
    //         xpag.pix_Recebido = res.data;
    //         sucessoMensagem("PIX Recebido com Sucesso!");
    //         setUrlQRCode('');
    //         setShowModalMeuPedido(false);
    //         clearInterval(intervalID);
    //         return;
    //       }
    //     }).catch(err => {
    //       console.log('erro ao tentar verificar o pix ', err)
    //       return false;
    //     });
    //   })
    // }
  }

  function moedaParaDecimal(valor) {
    return parseFloat(
      valor
        .replace(/[^\d,-]/g, '') // Remove R$, espaços etc.
        .replace(/\./g, '')      // Remove separador de milhar
        .replace(',', '.')       // Troca vírgula decimal por ponto
    );
  }

  function voltarParaContaFaturada(){
    setDestinoPagina("/faturado");
    setAbreComprovante(false);
    history.push("/faturado");
    return;
  }

  function habiltarTentativas(){
    setTrarnsacaoRecusada(false);
    setDesabilitarBotao(false);
  }  

  const handleConfirmarPagamento = async () => {
    setDesabilitarBotao(true);
    setCarregando(true)
    setTelaPixAindaNaoGerado(false)

    // //DEPOIS REMOVER 
    const _token = await PegarTokenTeste();
    // console.log('tooken que chegou ', props)
    // //DEPOIS REMOVER ACIMA

    if (metodoPagamento === 'pix') {
      const numericValue = parseFloat(valor.replace(/\D/g, "")) / 100;
      if (!numericValue || numericValue <= 0) {
        setErroValor(true);
        alert('Por favor, informe um valor válido para o Pix.');
        return;
      }
      try {

        // console.log("616 - ", _token);


        setDesabilitarBotao(true);

        const response = await api.post(
          'Creditos/criar-credito-avulso',
          {
            valor: valor,
            tipoPagamento: tipoPagamento,
            clienteId: clienteId,
            clienteIdLoja: clienteIdLoja,
            idFilial: idFilial,
            nome: nome,
            numeroCartao: numeroCartao,
            cpf: cpf,
            vencimento: vencimento,
            cvv: cvv,
            parcela: parcela,
            observacao: observacao
          },
          {
            headers: {
              'Authorization': `Bearer ${_token}`
            }
          }
        );

        // console.log('o que esta chegando no response data ', response.data)

        const mocado = '00020101021226850014br.gov.bcb.pix2563pix.santander.com.br/qr/v2/e2d9a23a-3195-4b1a-8163-e492b2ada1fe520400005303986540514.185802BR5925NAFIL AUTO PECAS LTDA 0016013VOLTA REDONDA62070503***6304B6F6';

        if (mocado !== null) {
          //          console.log('cai dentro do set do payload ')
          setPayload(mocado)
          setCarregando(false)
        }
        else {
          //          console.log('payload sendo considerado nulo ')
          setCarregando(false)
          setTelaPixAindaNaoGerado(true)
        }

      } catch (error) {
        if (error.response) {
          //          console.log('Erro da API:', error.response.status, error.response.data);
          //          console.log(`Erro ao processar Pix: ${error.response.data?.message || 'Tente novamente.'}`);
          setCarregando(false)
          setTelaPixAindaNaoGerado(true)
          ErroPix(`Erro ao processar Pix: ${error.response.data?.message || 'Tente novamente.'}`)
        } else if (error.request) {
          //          console.log('Sem resposta da API:', error.request);
          alert('Servidor não respondeu. Verifique sua conexão.');
          setCarregando(false)
          setTelaPixAindaNaoGerado(true)
          ErroPix('Servidor não respondeu. Verifique sua conexão.', error.request)
        } else {
          // console.log('Erro inesperado:', error.message);
          // console.log('Ocorreu um erro inesperado.');
          setCarregando(false)
          setTelaPixAindaNaoGerado(true)
          ErroPix('Erro inesperado:', error.message)
        }
      }     

    } else {

      // CARTÃO DE CRÉDITO  
      if (validateAll()) {
        //        console.log('Dados para pagamento via cartão:', { valor, cpf, numeroCartao, nome, vencimento, cvv, parcela, observacao });
        //        console.log('Processando pagamento via Cartão...');

        // CARTÃO DE CRÉDITO
        try {

          // console.log("670 - ", moedaParaDecimal(valor));

          const valorDecimal = moedaParaDecimal(valor);
          const _token = await PegarTokenTeste();

          //console.log("691 - ", _token);
          // console.log("691 - ", typeof valorDecimal); 
          // console.log("691 - ", typeof clienteId);  
          // console.log("691 - ", typeof idFilial); 
          // console.log("691 - ", typeof nome);
          // console.log("691 - ", typeof numeroCartao);
          // console.log("691 - ", typeof cpf);
          // console.log("691 - ", typeof vencimento);
          // console.log("691 - ", typeof cvv);
          // console.log("691 - ", typeof parcela);
          // console.log("691 - ", typeof observacao);
          let _dadosCartao = {
            valor: valorDecimal,
            tipoPagamento: 1,
            clienteId: clienteId,
            clienteIdLoja: 1,
            idFilial: idFilial,
            nome: nome,
            numeroCartao: numeroCartao,
            cpf: cpf,
            vencimento: vencimento,
            cvv: cvv,
            parcela: parcela,
            observacao: observacao
          };

          // console.log("691 - ", _dadosCartao);


          const response = await api.post(
            'Creditos/criar-credito-avulso',
            _dadosCartao,
            {
              headers: {
                'Authorization': `Bearer ${_token}`
              }
            }
          );
          setDadosComprovante(response.data);

          // console.log('RESPONSE: ', response.data);
          // console.log('RESPONSO: ', response.data);
          // console.log('RESPONSU: ', response.data.returnCode);

          if (response.data.returnCode == '00') {
            setTrarnsacaoRecusada(false);
            setAbreComprovante(true);
          }
          else {
            setAbreComprovante(false);
            setTrarnsacaoRecusada(true);
          }

          //     setDadosComprovante({
          //     data: resposta.dataHora,
          //     valor: resposta.amount,
          //     nsu: resposta.nsu,
          //     autorizacao: resposta.authorizationCode,
          //     finalCartao: resposta.last4,
          //     bandeira: resposta.brand,
          //     parcelas: resposta.installments
          // });

        } catch (error) {
          if (error.response) {
            //          console.log('Erro da API:', error.response.status, error.response.data);
            //          console.log(`Erro ao processar Pix: ${error.response.data?.message || 'Tente novamente.'}`);
            setCarregando(false)
            // setTelaPixAindaNaoGerado(true)
            // ErroPix(`Erro ao processar Pix: ${error.response.data?.message || 'Tente novamente.'}`)
          } else if (error.request) {
            //          console.log('Sem resposta da API:', error.request);
            alert('Servidor não respondeu. Verifique sua conexão.');
            setCarregando(false)
            // setTelaPixAindaNaoGerado(true)
            // ErroPix('Servidor não respondeu. Verifique sua conexão.', error.request)
          } else {
            //          console.log('Erro inesperado:', error.message);
            //          console.log('Ocorreu um erro inesperado.');
            setCarregando(false)
            // setTelaPixAindaNaoGerado(true)
            // ErroPix('Erro inesperado:', error.message)
          }
        }        
      } else {
        // console.log('Por favor, corrija os erros no formulário.');
      }
    }
  };

  useEffect(() => {
    if (payload != null && payload.length > 0) {
      const qrCode = new QRCodeStyling({
        width: 300,
        height: 300,
        data: payload,
        image:
          LogoN,
        dotsOptions: {
          color: "#000000",
          type: "rounded"
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 5
        }
      });
      qrCode.append(ref.current);
      setIntervalID(setInterval(verificarPagamentosPIX, 6000, 'Parameter 1', 'Parameter 2'));
    }
  }, [payload]);

  return (
    <>
    <BrowserView>
     <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <NavBarTop />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: 2 }}>
          <Typography variant="h5" gutterBottom sx={{ color: COLORS.primary, fontWeight: 'bold', textAlign: 'center', mb: 3 }}>
            Efetuar Créditos Avulsos
          </Typography>
          <Divider sx={{ mb: 4 }} />
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'medium' }}>
            Selecione o meio de pagamento:
          </Typography>

          <ToggleButtonGroup
            value={metodoPagamento}
            exclusive
            onChange={handleMetodoChange}
            fullWidth
            sx={{
              mb: 4,
              '& .MuiToggleButton-root': {
                py: 2,
                border: `1px solid ${COLORS.primary}`,
                color: COLORS.primary,
                '&.Mui-selected': {
                  bgcolor: COLORS.primary,
                  color: 'white',
                  '&:hover': {
                    bgcolor: COLORS.primary,
                  },
                },
              },
            }}
          >

            <ToggleButton value="pix" aria-label="pix">
              <Stack direction="row" spacing={1} alignItems="center">
                <PixIcon />
                <Typography>Pix</Typography>
              </Stack>
            </ToggleButton>

            <ToggleButton value="card" aria-label="cartao de credito">
              <Stack direction="row" spacing={1} alignItems="center">
                <CardIcon />
                <Typography>Cartão de Crédito</Typography>
              </Stack>
            </ToggleButton>

          </ToggleButtonGroup>


          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Valor do Crédito"
                variant="outlined"
                value={valor}
                onChange={handleValorChange}
                onBlur={validateValor}
                error={erroValor}
                helperText={erroValor ? "Informe um valor válido" : ""}
                placeholder="R$ 0,00"
                InputProps={{
                  sx: { fontWeight: 'bold', fontSize: '1.2rem', color: COLORS.primary }
                }}
              />
            </Grid>
          </Grid>          

          {metodoPagamento === 'card' ? (
            <Box component="form" sx={{ mt: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <InputMask
                    mask="999.999.999-99"
                    value={cpf}
                    onChange={(e) => setCpf(e.target.value)}
                    onBlur={validateCpf}
                  >
                    <TextField
                      fullWidth
                      label="CPF do Portador"
                      variant="outlined"
                      error={erroCpf}
                      helperText={erroCpf ? "CPF inválido" : ""}
                      placeholder="000.000.000-00"
                    />
                  </InputMask>

                </Grid>

                <Grid item xs={12} md={6}>
                  <InputMask
                    mask="9999 9999 9999 9999"
                    value={numeroCartao}
                    onChange={(e) => setNumeroCartao(e.target.value)}
                    onBlur={validateNumeroCartao}
                  >
                    <TextField
                      fullWidth
                      label="Número do Cartão"
                      variant="outlined"
                      error={erroNumeroCartao}
                      helperText={erroNumeroCartao ? "Número de cartão inválido" : (numeroCartao && numeroCartao.replace(/\s/g, '').length >= 6 ? CartaoCreditoTipo(numeroCartao.replace(/\s/g, '')) : '')}
                      placeholder="0000 0000 0000 0000"
                    />

                  </InputMask>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome do Portador (igual ao cartão)"
                    variant="outlined"
                    value={nome}
                    onChange={(e) => setNome(e.target.value.toUpperCase())}
                    onBlur={validateNomePortador}
                    error={erroNome}
                    helperText={erroNome ? "Informe o nome completo conforme impresso no cartão" : ""}
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputMask
                    mask="99/99"
                    value={vencimento}
                    onChange={(e) => setVencimento(e.target.value)}
                    onBlur={validateVencimento}
                  >
                    <TextField
                      fullWidth
                      label="Vencimento (MM/AA)"
                      variant="outlined"
                      error={erroVencimento}
                      helperText={erroVencimento ? "Data inválida" : ""}
                      placeholder="MM/AA"
                    />
                  </InputMask>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputMask
                    mask="9999"
                    maskChar=""
                    value={cvv}
                    onChange={(e) => setCvv(e.target.value)}
                    onBlur={validateCvv}
                  >
                    <TextField
                      fullWidth
                      label="CVV"
                      variant="outlined"
                      error={erroCvv}
                      helperText={erroCvv ? "CVV inválido" : ""}
                      placeholder="123"
                    />
                  </InputMask>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth error={erroParcelas}>
                    <InputLabel>Parcelas</InputLabel>
                    <Select
                      value={parcela}
                      label="Parcelas"
                      onChange={(e) => {
                        setParcela(e.target.value);
                        setErroParcelas(false);
                        setTipoPagamento(1);
                      }}
                      onBlur={validateParcelas}
                      disabled={carregandoParcelas || !isValorValidoEPositivo(valor)}
                    >
                      {parcelasDisponiveis.length > 0 ? (
                        parcelasDisponiveis.map((p) => (
                          <MenuItem key={p.value} value={p.value}>
                            {p.label}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="" disabled>
                          {carregandoParcelas ? 'Carregando parcelas...' : 'Informe um valor válido'}
                        </MenuItem>
                      )}
                    </Select>
                    {erroParcelas && <FormHelperText>Selecione o número de parcela</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

        ) : (

            <Box sx={{ textAlign: 'center', py: 4, bgcolor: COLORS.light, borderRadius: 2 }}>
              <PixIcon sx={{ fontSize: 60, color: COLORS.primary, mb: 2 }} />

              <Typography variant="body1" sx={{ mb: 4 }}>
                Pague com PIX e tenha aprovação instantânea.
              </Typography>

              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{ marginBottom: 4 }}
              >
                {/* ESTÁGIO 1: Tela inicial de seleção */}
                {telaPixAindaNaoGerado && (
                  <Grid item xs={12}>
                    {/* <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <img src={PixLogo} alt="Logo do Pix" style={{ width: 20, marginRight: 8 }} />
                      Emissão de qrcode
                    </Typography> */}
                  </Grid>
                )}

                {/* ESTÁGIO 2: Cliente selecionou e está carregando da API */}
                {!telaPixAindaNaoGerado && carregando && (
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                      <CircularProgress />
                    </Box>
                  </Grid>
                )}

                {/* ESTÁGIO 3: Payload recebido, renderiza o QR Code */}
                {!telaPixAindaNaoGerado && !carregando && payload && (
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: 200, mb: 2 }}>
                      <div ref={ref} />
                    </Box>
                    <Button
                      variant="outlined"
                      fullWidth
                      startIcon={<CopyIcon />}
                      onClick={copiarPix}
                      sx={{ color: COLORS.primary, borderColor: COLORS.primary }}
                    >
                      Copiar código Pix
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}
          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Observações"
                variant="outlined"
                multiline
                rows={4}
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Digite aqui alguma observação importante sobre este pagamento..."
                inputProps={{ maxLength: 150 }}
                helperText={`${observacao.length}/${150}`}
              />
            </Grid>
          </Grid>
          <Box sx={{ mt: 5 }}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              disabled={desabilitarBotao}
              //startIcon={<PaymentIcon />}
              startIcon={metodoPagamento === 'pix' ? <PixIcon /> : <PaymentIcon />} // fazendo alteração dos icones conforme metodo escolhodo 
              onClick={handleConfirmarPagamento}
              sx={{
                bgcolor: COLORS.primary,
                py: 1.5,
                '&:hover': {
                  bgcolor: '#1b5e20',
                },
              }}
            >{metodoPagamento === 'pix' ? 'Gerar QR Code Pix' : 'Finalizar Pagamento'}</Button>
          </Box>
        </Paper>
      </Container>
      {
        <Dialog open={abreComprovante} onClose={() => setAbreComprovante(false)} maxWidth="xs" fullWidth>
          <div id="comprovante_impressao">
            <DialogTitle align="center" sx={{ color: "green" }}>Comprovante de Pagamento</DialogTitle>
            <DialogContent>
              <div id="comprovante">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap={1.5}
                >
                  <img src={Confirmacao} alt="Feito" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '35px', height: 'auto' }} />
                  <img src={NAFIL_Logo} alt="Logo" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '120px', height: 'auto' }} />
                </Box>
              </div>
              <div id="comprovantes_tags">
                <hr />
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Data:</span>{" "} {FormatarDataHora(dadosComprovante.dateTime)}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Valor R$:</span>{" "} {FormatarMoeda(dadosComprovante.amount)}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>NSU:</span>{" "} {dadosComprovante.nsu}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Autorização:</span>{" "} {dadosComprovante.authorizationCode}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Cartão:</span>{" "} {dadosComprovante.cardBin} **** {dadosComprovante.last4}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Bandeira:</span>{" "} {dadosComprovante.Bandeira}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Parcelas:</span>{" "} {dadosComprovante.Parcelas}</p>
                <hr />
                <div style={{ textAlign: "center" }}>Obrigado Pela Preferência!</div>
              </div>
            </DialogContent>
          </div>
          <DialogActions className="nao-imprimir">
            <Button variant="contained" onClick={imprimirComprovante}>Imprimir</Button>
            <Button variant="outlined" onClick={() => voltarParaContaFaturada() }>Fechar</Button>
          </DialogActions>
        </Dialog>
      }

      {/* ERRO PAGAMENTOS ABAIXO */}
      {
        <Dialog open={abreTrarnsacaoRecusada} onClose={() => habiltarTentativas() } maxWidth="xs" fullWidth>
          <DialogTitle align="center" sx={{ color: "red" }}>Transação Recusada</DialogTitle>
          <DialogContent>
            <div id="comprovante_negado">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={1.5}
              >
                <img src={Exclamacao} alt="Falhou" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '35px', height: 'auto' }} />
                <img src={NAFIL_Logo} alt="Logo" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '120px', height: 'auto' }} />
              </Box>
              <hr />
              <p>Infelizmente Essa Transação Não Foi Autorizada</p>
              <p><span style={{ color: "#777", fontSize: "12px" }}>Código:</span>{" "}
                {dadosComprovante.returnCode}<br />
                <span style={{ color: "#777", fontSize: "12px" }}>Mensagem:</span><br />{traduzirMensagem(dadosComprovante.returnCode, dadosComprovante.returnMessage)}
              </p>
              <hr />
              <div style={{ textAlign: "center" }}>Tente Novamente!</div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={() => habiltarTentativas() }>Fechar</Button>
          </DialogActions>
        </Dialog>        
      }
      
      <ToastContainer />
      <Rodape />
     </Box>
    </BrowserView>

     <MobileView>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <NavBarTop />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: 2 }}>
          <Typography variant="h5" gutterBottom sx={{ color: COLORS.primary, fontWeight: 'bold', textAlign: 'center', mb: 3 }}>
            Efetuar Créditos Avulsos
          </Typography>
          <Divider sx={{ mb: 4 }} />
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'medium' }}>
            Selecione o meio de pagamento:
          </Typography>

          <ToggleButtonGroup
            value={metodoPagamento}
            exclusive
            onChange={handleMetodoChange}
            fullWidth
            sx={{
              mb: 4,
              '& .MuiToggleButton-root': {
                py: 2,
                border: `1px solid ${COLORS.primary}`,
                color: COLORS.primary,
                '&.Mui-selected': {
                  bgcolor: COLORS.primary,
                  color: 'white',
                  '&:hover': {
                    bgcolor: COLORS.primary,
                  },
                },
              },
            }}
          >

            <ToggleButton value="pix" aria-label="pix">
              <Stack direction="row" spacing={1} alignItems="center">
                <PixIcon />
                <Typography>Pix</Typography>
              </Stack>
            </ToggleButton>

            <ToggleButton value="card" aria-label="cartao de credito">
              <Stack direction="row" spacing={1} alignItems="center">
                <CardIcon />
                <Typography>Cartão de Crédito</Typography>
              </Stack>
            </ToggleButton>

          </ToggleButtonGroup>


          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Valor do Crédito"
                variant="outlined"
                value={valor}
                onChange={handleValorChange}
                onBlur={validateValor}
                error={erroValor}
                helperText={erroValor ? "Informe um valor válido" : ""}
                placeholder="R$ 0,00"
                InputProps={{
                  sx: { fontWeight: 'bold', fontSize: '1.2rem', color: COLORS.primary }
                }}
              />
            </Grid>
          </Grid>          

          {metodoPagamento === 'card' ? (
            <Box component="form" sx={{ mt: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputMask
                    mask="999.999.999-99"
                    value={cpf}
                    onChange={(e) => setCpf(e.target.value)}
                    onBlur={validateCpf}
                  >
                    <TextField
                      fullWidth
                      label="CPF do Portador"
                      variant="outlined"
                      error={erroCpf}
                      helperText={erroCpf ? "CPF inválido" : ""}
                      placeholder="000.000.000-00"
                    />
                  </InputMask>

                </Grid>

                <Grid item xs={12}>
                  <InputMask
                    mask="9999 9999 9999 9999"
                    value={numeroCartao}
                    onChange={(e) => setNumeroCartao(e.target.value)}
                    onBlur={validateNumeroCartao}
                  >
                    <TextField
                      fullWidth
                      label="Número do Cartão"
                      variant="outlined"
                      error={erroNumeroCartao}
                      helperText={erroNumeroCartao ? "Número de cartão inválido" : (numeroCartao && numeroCartao.replace(/\s/g, '').length >= 6 ? CartaoCreditoTipo(numeroCartao.replace(/\s/g, '')) : '')}
                      placeholder="0000 0000 0000 0000"
                    />

                  </InputMask>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome do Portador (igual ao cartão)"
                    variant="outlined"
                    value={nome}
                    onChange={(e) => setNome(e.target.value.toUpperCase())}
                    onBlur={validateNomePortador}
                    error={erroNome}
                    helperText={erroNome ? "Informe o nome completo conforme impresso no cartão" : ""}
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputMask
                    mask="99/99"
                    value={vencimento}
                    onChange={(e) => setVencimento(e.target.value)}
                    onBlur={validateVencimento}
                  >
                    <TextField
                      fullWidth
                      label="Vencimento (MM/AA)"
                      variant="outlined"
                      error={erroVencimento}
                      helperText={erroVencimento ? "Data inválida" : ""}
                      placeholder="MM/AA"
                    />
                  </InputMask>
                </Grid>
                <Grid item xs={12}>
                  <InputMask
                    mask="9999"
                    maskChar=""
                    value={cvv}
                    onChange={(e) => setCvv(e.target.value)}
                    onBlur={validateCvv}
                  >
                    <TextField
                      fullWidth
                      label="CVV"
                      variant="outlined"
                      error={erroCvv}
                      helperText={erroCvv ? "CVV inválido" : ""}
                      placeholder="123"
                    />
                  </InputMask>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth error={erroParcelas}>
                    <InputLabel>Parcelas</InputLabel>
                    <Select
                      value={parcela}
                      label="Parcelas"
                      onChange={(e) => {
                        setParcela(e.target.value);
                        setErroParcelas(false);
                        setTipoPagamento(1);
                      }}
                      onBlur={validateParcelas}
                      disabled={carregandoParcelas || !isValorValidoEPositivo(valor)}
                    >
                      {parcelasDisponiveis.length > 0 ? (
                        parcelasDisponiveis.map((p) => (
                          <MenuItem key={p.value} value={p.value}>
                            {p.label}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="" disabled>
                          {carregandoParcelas ? 'Carregando parcelas...' : 'Informe um valor válido'}
                        </MenuItem>
                      )}
                    </Select>
                    {erroParcelas && <FormHelperText>Selecione o número de parcela</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

        ) : (

            <Box sx={{ textAlign: 'center', py: 4, bgcolor: COLORS.light, borderRadius: 2 }}>
              <PixIcon sx={{ fontSize: 60, color: COLORS.primary, mb: 2 }} />

              <Typography variant="body1" sx={{ mb: 4 }}>
                Pague com PIX e tenha aprovação instantânea.
              </Typography>

              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{ marginBottom: 4 }}
              >
                {/* ESTÁGIO 1: Tela inicial de seleção */}
                {telaPixAindaNaoGerado && (
                  <Grid item xs={12}>
                    {/* <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <img src={PixLogo} alt="Logo do Pix" style={{ width: 20, marginRight: 8 }} />
                      Emissão de qrcode
                    </Typography> */}
                  </Grid>
                )}

                {/* ESTÁGIO 2: Cliente selecionou e está carregando da API */}
                {!telaPixAindaNaoGerado && carregando && (
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                      <CircularProgress />
                    </Box>
                  </Grid>
                )}

                {/* ESTÁGIO 3: Payload recebido, renderiza o QR Code */}
                {!telaPixAindaNaoGerado && !carregando && payload && (
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: 200, mb: 2 }}>
                      <div ref={ref} />
                    </Box>
                    <Button
                      variant="outlined"
                      fullWidth
                      startIcon={<CopyIcon />}
                      onClick={copiarPix}
                      sx={{ color: COLORS.primary, borderColor: COLORS.primary }}
                    >
                      Copiar código Pix
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}
          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Observações"
                variant="outlined"
                multiline
                rows={4}
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Digite aqui alguma observação importante sobre este pagamento..."
                inputProps={{ maxLength: 150 }}
                helperText={`${observacao.length}/${150}`}
              />
            </Grid>
          </Grid>
          <Box sx={{ mt: 5 }}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              disabled={desabilitarBotao}
              //startIcon={<PaymentIcon />}
              startIcon={metodoPagamento === 'pix' ? <PixIcon /> : <PaymentIcon />} // fazendo alteração dos icones conforme metodo escolhodo 
              onClick={handleConfirmarPagamento}
              sx={{
                bgcolor: COLORS.primary,
                py: 1.5,
                '&:hover': {
                  bgcolor: '#1b5e20',
                },
              }}
            >{metodoPagamento === 'pix' ? 'Gerar QR Code Pix' : 'Finalizar Pagamento'}</Button>
          </Box>
        </Paper>
      </Container>
      {
        <Dialog open={abreComprovante} onClose={() => setAbreComprovante(false)} maxWidth="xs" fullWidth>
          <div id="comprovante_impressao">
            <DialogTitle align="center" sx={{ color: "green" }}>Comprovante de Pagamento</DialogTitle>
            <DialogContent>
              <div id="comprovante">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap={1.5}
                >
                  <img src={Confirmacao} alt="Feito" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '35px', height: 'auto' }} />
                  <img src={NAFIL_Logo} alt="Logo" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '120px', height: 'auto' }} />
                </Box>
              </div>
              <div id="comprovantes_tags">
                <hr />
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Data:</span>{" "} {FormatarDataHora(dadosComprovante.dateTime)}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Valor R$:</span>{" "} {FormatarMoeda(dadosComprovante.amount)}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>NSU:</span>{" "} {dadosComprovante.nsu}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Autorização:</span>{" "} {dadosComprovante.authorizationCode}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Cartão:</span>{" "} {dadosComprovante.cardBin} **** {dadosComprovante.last4}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Bandeira:</span>{" "} {dadosComprovante.Bandeira}</p>
                <p style={{ marginTop: 2, marginBottom: 2 }}><span style={{ color: "#777", fontSize: "12px" }}>Parcelas:</span>{" "} {dadosComprovante.Parcelas}</p>
                <hr />
                <div style={{ textAlign: "center" }}>Obrigado Pela Preferência!</div>
              </div>
            </DialogContent>
          </div>
          <DialogActions className="nao-imprimir">
            <Button variant="contained" onClick={imprimirComprovante}>Imprimir</Button>
            <Button variant="outlined" onClick={() => voltarParaContaFaturada() }>Fechar</Button>
          </DialogActions>
        </Dialog>
      }

      {/* ERRO PAGAMENTOS ABAIXO */}
      {
        <Dialog open={abreTrarnsacaoRecusada} onClose={() => habiltarTentativas() } maxWidth="xs" fullWidth>
          <DialogTitle align="center" sx={{ color: "red" }}>Transação Recusada</DialogTitle>
          <DialogContent>
            <div id="comprovante_negado">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={1.5}
              >
                <img src={Exclamacao} alt="Falhou" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '35px', height: 'auto' }} />
                <img src={NAFIL_Logo} alt="Logo" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '120px', height: 'auto' }} />
              </Box>
              <hr />
              <p>Infelizmente Essa Transação Não Foi Autorizada</p>
              <p><span style={{ color: "#777", fontSize: "12px" }}>Código:</span>{" "}
                {dadosComprovante.returnCode}<br />
                <span style={{ color: "#777", fontSize: "12px" }}>Mensagem:</span><br />{traduzirMensagem(dadosComprovante.returnCode, dadosComprovante.returnMessage)}
              </p>
              <hr />
              <div style={{ textAlign: "center" }}>Tente Novamente!</div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={() => habiltarTentativas() }>Fechar</Button>
          </DialogActions>
        </Dialog>        
      }
      
      <ToastContainer />
      <Rodape />
     </Box>
     </MobileView>


    </>
  );
};

export default PagamentoAvulso;

